<div class="ppl-mt20 p-4">
    @if (errorcodeEntries && errorcodeEntries.controls && errorcodeEntries.controls.length) {
    <form nz-form nz-row [formGroup]="staffErrorcodesForm" class="ppl-p0">
        <table class="table">
            <thead>
                <tr>
                    <th style="background-color: #a8e4e14d; width: 10%;">Code</th>
                    <th style="background-color: #a8e4e14d; width: 10%;">Description</th>
                    <th style="background-color: #a8e4e14d; width: 10%;">System Disposition</th>
                    @if(!disabled) {
                    <th style="background-color: #a8e4e14d; width: 10%;">Disposition</th>
                    }
                    <th style="background-color: #a8e4e14d; width: 10%;">Comments</th>
                    <th style="background-color: #a8e4e14d; width: 10%;">Reason</th>
                </tr>
            </thead>
            <tbody formArrayName="errorcodeEntries">
                <tr *ngFor="let entry of errorcodeEntries.controls; let i = index" [formGroupName]="i">
                    <td>
                        <span>{{ entry.get('code')?.value }}</span>
                    </td>
                    <td>
                        <span>{{ entry.get('desc')?.value }}</span>
                    </td>
                    <td>
                        <span>{{ entry.get('systemDisposition')?.value }}</span>
                    </td>
                    @if(!disabled) {
                    <td>
                        <nz-select class="ppl-select" formControlName="dispositionLkp"
                            nzPlaceHolder="Select disposition" nzShowSearch nzAllowClear>
                            <nz-option *ngFor="let opt of getFilteredDispositionList(entry.value)"
                                [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                        </nz-select>
                    </td>
                    }
                    <td>
                        <input nz-input formControlName="comments" id="comments" nzPlaceHolder="Enter comments"/>
                        <div *ngIf="entry.get('comments')?.hasError('required') && entry.get('dispositionLkp')?.value"
                            class="error-message">
                            Comments are required.
                        </div>
                        <div *ngIf="entry.get('comments')?.hasError('maxlength')"
                            class="error-message">
                            Comments cannot exceed 250 characters.
                        </div>
                    </td>
                    <td>
                        <nz-select class="ppl-select" formControlName="reasonLkp" nzPlaceHolder="Select reason"
                            nzShowSearch nzAllowClear>
                            <nz-option *ngFor="let opt of getReasonListForEntry(entry.get('dispositionLkp')?.value)" [nzLabel]="opt.lkpValueName"
                                [nzValue]="opt.lkpValueCode"></nz-option>
                        </nz-select>
                        <div *ngIf="entry.get('reasonLkp')?.hasError('required') && entry.get('dispositionLkp')?.value"
                            class="error-message">
                            Reason is required.
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="custom-row" style="width: 100%;">
            <span *ngIf="staffErrorcodesForm.hasError('atLeastOneDisposition') && isSubmitted"
                class="error-message mr-4 pt-2">
                At least one disposition must be selected.
            </span>

            @if(!disabled) {
            <ppl-button (click)="onSave()" [styleString]="'margin-right: 8px;'" label="Save" icon="fa fa-check-circle"
                [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
            }
        </div>
    </form>
    } @else {
        <div class="alert alert-warning">No Records Found.</div>
    }
</div>